(() => {
  const preorderHandles = new Set([
    'pistach-dekadent-reeks',
    'vanielje-dekadent-reeks',
  ]);

  const productNotes = new Map([
    ['vanielje-dekadent-reeks', 'Franse vanielje · Wit blomme · Romerig'],
    ['saartjie-geur', 'Peer · Koffie · Vanielje'],
    ['pistach-dekadent-reeks', 'Pistachio · Karamel · Suiker'],
    ['stephanus-geur', 'Klapperwater · Groen vy · Sandaalhout'],
    ['katarina-geur', 'Sjampanje-rosé · Perskebloeisel · Roos'],
    ['theodorus-geur', 'Sisiliese mandaryn · Neroli · Patchouli'],
    ['herklaas-geur', 'Bergamot · Pynappel · Rokerige berk'],
    ['wilhelm-geur', 'Kardemom · Oud · Sandaalhout'],
    ['isabella-geur', 'Ambrette-saad · Seesout · Salie'],
    ['jacobus-geur', 'Viooltjieblaar · Salie · Vetiver'],
  ]);

  const buttonLabel = 'Waglys – bestel nou';
  const shippingNote = 'Versend binne twee weke.';
  let scheduled = false;

  const enhanceCarouselCards = () => {
    scheduled = false;

    document.querySelectorAll('.fx-cps-box-pro-card').forEach((card) => {
      const productLink = card.querySelector('a[href*="/products/"]');
      if (!productLink) return;

      let handle;
      try {
        const productUrl = new URL(productLink.href, window.location.origin);
        const match = productUrl.pathname.match(/\/products\/([^/?#]+)/);
        handle = match && match[1];
      } catch (error) {
        return;
      }

      const cardInfo = card.querySelector('.fx-cps-box-pro-card-info');
      const cardButtons = card.querySelector('.fx-cps-box-pro-card-buttons');
      const noteText = productNotes.get(handle);

      if (cardInfo && noteText) {
        let notes = cardInfo.querySelector('.geur-carousel-notes');

        if (!notes) {
          notes = document.createElement('div');
          notes.className = 'geur-carousel-notes';

          const productName = Array.from(cardInfo.children).find(
            (element) => element.tagName === 'SPAN'
          );

          if (productName) {
            productName.insertAdjacentElement('afterend', notes);
          } else {
            cardInfo.prepend(notes);
          }
        }

        if (notes.textContent !== noteText) {
          notes.textContent = noteText;
        }
      }

      if (!preorderHandles.has(handle)) return;

      card.classList.add('geur-preorder-card');

      const addButton = card.querySelector('.fx-cps-box-pro-add-to-cart');
      if (addButton) {
        if (addButton.textContent.trim() !== buttonLabel) {
          addButton.textContent = buttonLabel;
        }
        addButton.classList.add('geur-preorder-button');
        addButton.setAttribute('aria-label', buttonLabel + '. ' + shippingNote);

        if (!addButton.dataset.geurPreorderEnhanced) {
          addButton.dataset.geurPreorderEnhanced = 'true';
          addButton.setAttribute('role', 'button');
          addButton.setAttribute('tabindex', '0');
          addButton.addEventListener('keydown', (event) => {
            if (event.key === 'Enter' || event.key === ' ') {
              event.preventDefault();
              addButton.click();
            }
          });
        }
      }

      if (cardInfo && cardButtons && !cardInfo.querySelector('.geur-preorder-note')) {
        const note = document.createElement('div');
        note.className = 'geur-preorder-note';
        note.textContent = shippingNote;
        cardInfo.insertBefore(note, cardButtons);
      }
    });
  };

  const scheduleEnhancement = () => {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(enhanceCarouselCards);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleEnhancement, { once: true });
  } else {
    scheduleEnhancement();
  }

  const observer = new MutationObserver(scheduleEnhancement);
  observer.observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', scheduleEnhancement);
})();